import type { ReactNode } from "react";

export interface FrameOverlayProps {
  children: ReactNode;
}

/**
 * Portal target for modals, drawers, sheets, and other surfaces that overlay
 * page content. Frame mounts these into a body-level portal at z-60+ so
 * they sit above all other Frame chrome.
 *
 * Today most modals self-portal via React Aria's `Modal`/`Dialog` primitives;
 * this slot is the canonical Frame-aware mount point for cases where the
 * consumer wants Frame to manage layering.
 */
export function FrameOverlay({ children }: FrameOverlayProps) {
  return <>{children}</>;
}
